const environnementConfig = {
  gtag: 'XXXXXXXX',
  aw_gtag: 'XXXXXXXX',
  microsoftAds: 'XXXXXXXX',
}

export const config = environnementConfig;
